/** Date & money formatting for Command Room. Timezone: Asia/Kolkata. */

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00+05:30` : iso);
  if (isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata",
  }).format(d);
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric", month: "short", year: "numeric",
    hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata",
  }).format(d);
}

/** Indian-style money: ₹12.50 L / ₹1.25 Cr / en-IN grouping below one lakh. */
export function formatINR(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  const v = Number(n);
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (abs >= 1e7) {
    const cr = abs / 1e7;
    return `${sign}₹${cr.toFixed(2).replace(/\.00$/, "")} Cr`;
  }
  if (abs >= 1e5) {
    const l = abs / 1e5;
    return `${sign}₹${l.toFixed(2).replace(/\.00$/, "")} L`;
  }
  return `${sign}₹${abs.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export const HEALTH_LABEL = { ok: "On track", watch: "Watch", risk: "At risk" };
export const STAGE_LABEL = { running: "Running", building: "Building", pipeline: "Pipeline" };
